import { TRequestValues } from '../../types/requestDemand';
import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../../store';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import { OfferTypeLabel, RoomsLabel } from '../../constants/demand';
import { EUserType } from '../../constants/requestDemand';
import { getApplicationFormQuery } from '../../components/demand/utils/getApplicationFormQuery';
import { getFullAddressFromGeo } from '../../components/demand/utils/getFullAddressFromGeo';
import { getName } from '../../components/demand/utils';
import { sendDemandRequest } from './sendDemandRequest';

export const submitDemandRequest = (parameters: TRequestValues): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    const { userType, phone, email } = parameters;
    const {
      offerData: { offer, user },
    } = getState();
    const { id, dealType, geo } = offer;
    const firstName = user && user.isAuthenticated ? user.firstName : '';
    const lastName = user && user.isAuthenticated ? user.lastName : '';
    const realtyCategory = isCommercial(getOfferType(offer)) ? 'commercial' : 'flat';
    const realtyType = OfferTypeLabel[getOfferType(offer)] || 'other';
    const roomCount =
      RoomsLabel[offer.roomsCount] || (offer.flatType && offer.flatType !== 'rooms' ? offer.flatType : '');

    if (userType === EUserType.HOME_OWNER) {
      window.location.assign(
        `/application-form/${getApplicationFormQuery(
          phone,
          email,
          realtyType,
          realtyCategory,
          dealType,
          'after_similar',
          getFullAddressFromGeo(geo.address),
          roomCount,
        )}`,
      );
    } else {
      dispatch(
        sendDemandRequest({
          email,
          fullName: getName(firstName || '', lastName || ''),
          isHomeowner: false,
          offerId: id,
          phone,
          source: 'Card',
        }),
      );
    }

    return Promise.resolve();
  };
};
